import { IS_ACTIVE } from '../constants';

import getURLHash from '../helpers/get-url-hash';
import { scrollToElement } from './scroll-to-hash';

export default function tabs(element: string): void {
    const elm: HTMLDivElement | null = document.querySelector(element);
    const navCnt: NodeListOf<HTMLDivElement> | null | undefined = elm?.querySelectorAll('.js-tabs__nav');
    const tabsCnt: HTMLDivElement | null | undefined = elm?.querySelector('.js-tabs__cnt');
    const allTabContents: NodeListOf<HTMLDivElement> | null | undefined = tabsCnt?.querySelectorAll('.tab-content');

    navCnt?.forEach((nav: HTMLDivElement) => {
        const allTabs: NodeListOf<HTMLAnchorElement> | null | undefined = nav?.querySelectorAll('a');
        nav.addEventListener('click', (e: Event) => {
            e.preventDefault();

            const target: EventTarget | null = e.target;
            if (!(target instanceof HTMLAnchorElement)) {
                return;
            }

            const id: string | null = target?.getAttribute('href');

            allTabs?.forEach((tab: HTMLAnchorElement) => {
                tab.classList.remove(IS_ACTIVE);
                if (tab.hasAttribute('href') && tab.getAttribute('href') === id) {
                    tab.classList.add(IS_ACTIVE);
                }
            });

            allTabContents?.forEach((tabContent: HTMLDivElement) => {
                tabContent.style.display = 'none';
                if (tabContent.hasAttribute('name') && tabContent.getAttribute('name') === id?.split('#')[1]) {
                    tabContent.style.display = 'block';
                }
            });
        });

        setActiveQuestion(nav, tabsCnt);
    });
}

function setActiveQuestion(navCnt: HTMLDivElement | null | undefined, tabsCnt: HTMLDivElement | null | undefined): void {
    const hash: string | null = getURLHash(document.location);

    if (hash && navCnt && tabsCnt) {
        const activeElement: HTMLAnchorElement | null = navCnt.querySelector(`a[href="${hash}"]`);
        const activeQuestion: HTMLDivElement | null = tabsCnt.querySelector(`[name="${hash.split('#')[1]}"]`);

        if (activeElement) {
            activeElement.click();
            scrollToElement('#tabs__nav');
        }

        if (activeQuestion) {
            const activeTabName: string | null | undefined = activeQuestion.closest('.tab-content')?.getAttribute('name');
            const activeTab: HTMLAnchorElement | null = navCnt.querySelector(`a[href="#${activeTabName}"]`);

            activeTab?.click();
            activeQuestion.click();
            scrollToElement(hash);
        }
    }
}
